// eslint-disable-next-line import/no-unresolved
import { Config, Layout, PlotData } from 'plotly.js-basic-dist';

export const plotDefaultData: Partial<PlotData>[] = [
  {
    hole: 0.6,
    type: 'pie',
    textinfo: 'none',
    hovertemplate: '%{label}<extra></extra>',
    marker: {
      colors: ['#6EA961', '#B5D6AE', '#2E5482', '#B4D2EC', '#6D5989', '#DBBBE5', '#C58C1D', '#E9D48D'],
    },
    direction: 'clockwise',
    // Because we use older version of types, but this prop exists
    // @ts-ignore
    sort: false,
  },
];

export const plotDefaultConfig: Partial<Config> = {
  autosizable: true,
  displayModeBar: false,
  responsive: true,
};

export const plotLayoutConfig: Partial<Layout> = {
  width: 326,
  height: 400,
  showlegend: true,
  legend: {
    xanchor: 'left',
    yanchor: 'top',
    x: -50 / 326,
    y: 0,
  },
  // @ts-ignore this prop is available
  traces: {
    domain: {
      x: [0, 1],
      y: [0.2, 1],
    },
  },
  margin: {
    t: 0,
    r: 40,
    b: 130,
    l: 40,
  },
};

export const plotLayoutConfigSmall: Partial<Layout> = {
  ...plotLayoutConfig,
  height: 340,
  margin: {
    ...plotLayoutConfig.margin,
    b: 30,
  },
};
